<template>
  <b-input-group class="spin-button-with-input">
    <b-input-group-prepend>
      <b-button
        type="button"
        variant="outline-secondary"
        :aria-label="label + ' −'"
        :disabled="disabled || value <= min"
        @click="updateValue(value - 1)"
      >
        −
      </b-button>
    </b-input-group-prepend>
    <b-form-input
      :id="id"
      :value="value"
      type="number"
      number
      :min="min"
      :max="max"
      step="1"
      class="text-center"
      :disabled="disabled"
      @change="updateValue($event)"
      @blur="resetInput"
    />
    <b-input-group-append>
      <b-button
        type="button"
        variant="outline-secondary"
        :aria-label="label + ' +'"
        :disabled="disabled || value >= max"
        @click="updateValue(value + 1)"
      >
        +
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
    value: { type: Number, required: true },
    label: { type: String, required: true },
    min: { type: Number, default: 1 },
    max: { type: Number, required: true },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    updateValue (value) {
      if (this.disabled) {
        return
      }
      const numericValue = Number(value)
      if (String(value).trim() === '' || !Number.isInteger(numericValue)) {
        return
      }
      const nextValue = Math.min(this.max, Math.max(this.min, numericValue))
      this.$emit('input', nextValue)
      this.$emit('change', nextValue)
    },
    resetInput (event) {
      this.$nextTick(() => {
        event.target.value = this.value
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.spin-button-with-input {
  width: 10rem;
  display: inline-flex;
}
</style>
